import palette from "../../../theme/palette";
import CrossIconSvg from "../../../assets/svg-fc/CrossIconSvg";
import { Box } from "@mui/material";

interface IProps {
	onClose: () => void;
}

const DialogCrossCircle = ({ onClose }: IProps) => {
	return (
		<Box
			sx={{
				background: "#F2F2F2",
				height: 32,
				width: 32,
				borderRadius: "50%",
				alignItems: "center",
				display: "flex",
				justifyContent: "center",
				cursor: "pointer",
			}}
			onClick={onClose}
		>
			<CrossIconSvg size="12" color={palette.secondary.main} fill={palette.secondary.main} />
		</Box>
	);
};

export default DialogCrossCircle;
